import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Provider as AulaThemeProvider,
  theme as aulauiTheme,
} from '@ublend-npm/aulaui-next';
import { createTheme } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/CheckCircleRounded';
import THEME from '$variables/theme';
import { StyledSnackbar } from './Toast.styled';

const MainTheme = createTheme(THEME);

export const NotificationTypes = {
  SUCCESS: 'success',
  FAIL: 'fail',
};

const ICONS = {
  [NotificationTypes.SUCCESS]: () => (
    <CheckIcon style={{ color: aulauiTheme.color.designSystem.success }} />
  ),
  [NotificationTypes.FAIL]: () => (
    <WarningIcon
      style={{ color: aulauiTheme.color.designSystem.blackOpacity60 }}
    />
  ),
};

const Toast = ({ message, type }) => {
  const [open, setOpen] = useState(true);

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const Icon = ICONS[type];

  return (
    <AulaThemeProvider theme={MainTheme}>
      <StyledSnackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={message}
        icon={<Icon />}
        data-testid="toast-message"
        isLightVariant
      />
    </AulaThemeProvider>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(NotificationTypes)),
};

Toast.defaultProps = {
  type: 'success',
};

export default Toast;
